import { useState,useContext,useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import annualpass from '../../../assets/images/annualpass.jpg';
import daypass from '../../../assets/images/daypass.gif';
import { PassContext } from '../../../hooks/PassContext.js';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
export const Home = () => {
    const { types,error } = useContext(PassContext);  // Get types and  from the context
    const [errorMessage, setErrorMessage] = useState('');
    useEffect(() => {
        if (error) {  // Show error only if the API call has failed
            setErrorMessage('We encountered an issue while loading pass types. Please refresh the page or try again later');
        } else {
            setErrorMessage('');
        }
    }, [error]);

    return (
        <>
            <div className="home">
                <div className="cartBG">
                    <h1 className="home-head">Choose a Washington State Discover Pass.</h1>
                    {
                        errorMessage?<><h2 className='errorHandled'>{errorMessage}</h2></>:
                        types.length === 0 ? (
                            <div className="skeleton-wrapper d-flex flex-column">
                                <Skeleton height={30} width="100px" />
                                <Skeleton height={15} width="60%" />
                                <Skeleton height={15} width="50%" />
                                <Skeleton height={100} width="100%" />
                                <Skeleton height={30} width="40%" />
                                <Skeleton count={5} width="80%" />
                            </div>
                        ) : 
                        <>
                            <div className="container-fluid">
                                <div className="row justify-content-center homePass">
                                    {types && types.map((type,index) => {
                                        return (
                                            <div key={index} className="col-12 col-sm-6 col-md-6 col-lg-5 col-xl-5 mb-4">
                                                <div className="h-100">
                                            <Link
                                            key={index}
                                            to={`/shop/${type.pageSlug}`}
                                            state={{ passID: type.passID,passGUID:type.passGuid }}
                                            className="home-button d-block p-4"
                                            >   
                                                <div className="home-button-head">{type.shortName}</div>
                                                <img src={type.image === 'annualpass.gif' ? annualpass : daypass} alt={type.image  === 'annualpass.gif' ? "annual-pass":"one-day-pass"}  className="img-fluid"></img>
                                                <p>{type.shortDescription}</p>
                                                <div className="home-button-price">$ {(type.price+type.processingFee).toFixed(2)}</div>
                                            </Link>
                                            </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
        </>
    );
};